module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', [_c('div', {
    staticClass: "settings-hub"
  }, [_c('div', {
    staticClass: "settings-nav-panel"
  }, [_c('div', {
    staticClass: "settings-hub-title-wrap"
  }, [_c('h1', {
    staticClass: "settings-hub-title"
  }, [_vm._v("Settings")])]), _vm._v(" "), _c('div', {
    staticClass: "settings-nav-group"
  }, [_c('div', {
    staticClass: "settings-nav-group-label"
  }, [_vm._v("ACCOUNT")]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/product-tracking",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Product Tracking")])]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/account",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Account & Team")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "settings-nav-group"
  }, [_c('div', {
    staticClass: "settings-nav-group-label"
  }, [_vm._v("NOTIFICATIONS")]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/alerts",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Alert Settings")])]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/sellers",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Hijacker")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "settings-nav-group"
  }, [_c('div', {
    staticClass: "settings-nav-group-label"
  }, [_vm._v("BILLING & COSTS")]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/billing",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Subscription & Billing")])]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/bulk-cogs",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Bulk COGS & Margins")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "settings-nav-group"
  }, [_c('div', {
    staticClass: "settings-nav-group-label"
  }, [_vm._v("INTEGRATIONS")]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/webhooks",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z",
      "fill": "currentColor",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Webhooks")])]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/api-keys",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("API Keys")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "settings-content-panel"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59e2cff7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/SettingsHubPage.vue
// module id = 779
// module chunks = 2